export default "__VITE_ASSET__CbHfypBy__"